import { aJ as p, aK as e } from "../tokens-D9z8Q6nJ.js";
const a = {
  primary: "rgba(102, 188, 255, 0.16)",
  error: "rgba(255, 128, 140, 0.16)"
}, i = {
  defaultProps: {
    disableElevation: !0,
    variant: "contained"
  },
  styleOverrides: {
    root: ({ theme: r }) => ({
      variants: [
        {
          props: {
            variant: "outlined",
            color: "primary"
          },
          style: {
            "&:hover": {
              background: a.primary
            }
          }
        },
        {
          props: {
            variant: "outlined",
            color: "error"
          },
          style: {
            "&:hover": {
              background: a.error
            }
          }
        },
        {
          props: {
            variant: "text",
            color: "primary"
          },
          style: {
            "&:hover": {
              background: a.primary
            }
          }
        },
        {
          props: {
            variant: "text",
            color: "error"
          },
          style: {
            "&:hover": {
              background: a.error
            }
          }
        },
        {
          props: {
            variant: "contained",
            color: "cta"
          },
          style: {
            background: `linear-gradient(180deg, ${r.palette.cta.dark} 0%, ${r.palette.cta.light} 100%)`,
            boxShadow: `
                1px 1px 1px 0px ${r.palette.cta.light} inset,
                -1px -1px 1px 1px rgba(255, 186, 0, 0.50) inset,
                1px 1px 2px 0px rgba(0, 19, 51, 0.25),
                1px 2px 5px 0px rgba(0, 19, 51, 0.10),
                5px 12px 17px -3px rgba(255, 253, 144, 0.15);
              `,
            "&:hover": {
              background: `linear-gradient(180deg, ${r.palette.cta.dark} 0%, ${r.palette.cta.dark} 100%)`,
              boxShadow: `
                  8px 35px 24px -24px rgba(0, 19, 51, 0.10),
                  4px 8px 10px -5px rgba(0, 19, 51, 0.14),
                  4px 16px 24px 2px rgba(0, 19, 51, 0.08),
                  3px 6px 30px 5px rgba(0, 19, 51, 0.06);
                `
            },
            "&.Mui-focusVisible": {
              background: `linear-gradient(180deg, ${r.palette.cta.dark} 0%, ${r.palette.cta.light} 100%);`
            },
            "&:active": {
              background: `linear-gradient(180deg, ${r.palette.cta.light} 0%, ${r.palette.cta.light} 100%)`,
              boxShadow: `
                  0px 2px 5px 0px rgba(0, 37, 102, 0.10) inset,
                  0px 1px 2px 0px rgba(0, 37, 102, 0.25) inset,
                  0px 12px 17px -3px rgba(255, 217, 0, 0.16) inset;
                `
            }
          }
        },
        {
          props: {
            variant: "contained",
            color: "primary"
          },
          style: {
            background: `linear-gradient(180deg, ${r.palette.primary.dark} 0%, ${r.palette.primary.main} 100%)`,
            boxShadow: `
                1px 1px 1px 0px ${r.palette.primary.main} inset,
                -1px -1px 1px 1px rgba(0, 43, 255, 0.80) inset,
                1px 1px 2px 0px rgba(0, 24, 85, 0.25),
                1px 2px 5px 0px rgba(0, 93, 255, 0.30),
                5px 12px 17px -3px rgba(0, 93, 255, 0.16)
              `,
            "&:hover": {
              background: `
                  linear-gradient(0deg, ${r.palette.primary.dark} 0%,  ${r.palette.primary.dark} 100%),
                  linear-gradient(180deg,  ${r.palette.primary.dark} 0%,  ${r.palette.primary.main} 100%);
                `,
              boxShadow: `
                  8px 35px 24px -24px rgba(0, 19, 51, 0.10),
                  4px 8px 10px -5px rgba(0, 19, 51, 0.14),
                  4px 16px 24px 2px rgba(0, 19, 51, 0.08),
                  3px 6px 30px 5px rgba(0, 19, 51, 0.06);
                 `
            },
            "&.Mui-focusVisible": {
              background: `
                  linear-gradient(0deg, rgba(102, 188, 255, 0.16) 0%, rgba(102, 188, 255, 0.16) 100%),
                  linear-gradient(180deg, ${r.palette.primary.dark} 0%, ${r.palette.primary.main} 100%)
                `
            },
            "&:active": {
              background: `
                  linear-gradient(0deg, rgba(102, 188, 255, 0.16) 0%, rgba(102, 188, 255, 0.16) 100%),
                  linear-gradient(180deg, ${r.palette.primary.dark} 0%, ${r.palette.primary.light} 100%);
                `,
              boxShadow: `
                  0px 4px 8px 0px rgba(0, 37, 102, 0.10) inset,
                  0px 2px 4px 0px rgba(0, 37, 102, 0.25) inset;
                `
            }
          }
        },
        {
          props: {
            variant: "contained",
            color: "error"
          },
          style: {
            background: `linear-gradient(180deg, ${r.palette.error.main} 0%, ${r.palette.error.light} 100%);`,
            boxShadow: `
                1px 1px 1px 0px ${p} inset,
                -1px -1px 1px 1px rgba(153, 0, 15, 0.25) inset,
                1px 1px 2px 0px rgba(153, 0, 15, 0.25),
                1px 2px 5px 0px rgba(153, 0, 15, 0.10),
                5px 12px 17px -3px rgba(204, 0, 20, 0.15);
              `,
            "&:hover": {
              background: `linear-gradient(180deg, ${r.palette.error.dark} 0%, ${r.palette.error.dark} 100%);`,
              boxShadow: `
                  8px 35px 24px -24px rgba(0, 19, 51, 0.10),
                  4px 8px 10px -5px rgba(0, 19, 51, 0.14),
                  4px 16px 24px 2px rgba(0, 19, 51, 0.08),
                  3px 6px 30px 5px rgba(0, 19, 51, 0.06)
                `
            },
            "&.Mui-focusVisible": {
              background: `
                  linear-gradient(0deg, rgba(255, 128, 140, 0.16) 0%, rgba(255, 128, 140, 0.16) 100%),
                  linear-gradient(180deg, ${r.palette.error.main} 0%, ${e} 100%)
                `
            },
            "&:active": {
              background: ` linear-gradient(180deg, ${r.palette.error.main} 0%, ${r.palette.error.light} 100%);`,
              boxShadow: `
                  -1px -1px 1px 1px ${r.palette.error.main} inset,
                  1px 1px 1px 0px ${r.palette.error.light} inset
                `
            }
          }
        },
        {
          props: {
            variant: "contained",
            disabled: !0
          },
          style: {
            background: "none"
          }
        },
        {
          props: {
            size: "large"
          },
          style: {
            fontSize: "1.125rem",
            padding: "0.5rem, 1.5rem",
            "&.Mui-focusVisible": {
              outline: `2px solid ${r.palette.primary.main}`,
              outlineOffset: "2px"
            }
          }
        },
        {
          props: {
            size: "medium"
          },
          style: {
            fontSize: "1rem",
            padding: "0.375rem, 1rem",
            "&.Mui-focusVisible": {
              outline: `2px solid ${r.palette.primary.main}`,
              outlineOffset: "2px"
            }
          }
        },
        {
          props: {
            size: "small"
          },
          style: {
            fontSize: "0.875rem",
            padding: "0.25rem, 0.75rem",
            "&.Mui-focusVisible": {
              outline: `2px solid ${r.palette.primary.main}`,
              outlineOffset: "2px"
            }
          }
        }
      ]
    })
  }
};
export {
  i as default
};
